import { render, staticRenderFns } from "./SecondaryMarketSwaps.vue?vue&type=template&id=5b97fa00&"
import script from "./SecondaryMarketSwaps.vue?vue&type=script&lang=js&"
export * from "./SecondaryMarketSwaps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports